import AddFieldForm from './AddFieldForm';
import FieldsList from './FieldsList';

export default function FieldsConfiguration({
  fields,
  draftField,
  handleDraftFieldChange,
  addField,
  updateField,
  removeField,
  getFieldTypeLabel,
  collections,
}) {
  // console.log(`TCL -> FieldsConfiguration.jsx:14 -> FieldsConfiguration -> collections:`, collections)
  // Add customers to collections list
  const customerCollection = {
    id: 'Customers',
    name: 'Customers',
    fields: [
      { name: 'name', type: 'text' },
      { name: 'tel', type: 'text' },
      { name: 'email', type: 'text' },
    ]
  }
  const enhancedCollections = [...collections, customerCollection]
  return (
    <>
      {fields.length > 0 && (
        <FieldsList
          fields={fields}
          updateField={updateField}
          removeField={removeField}
          getFieldTypeLabel={getFieldTypeLabel}
          collections={enhancedCollections}
        />
      )}

      <AddFieldForm
        draftField={draftField}
        handleDraftFieldChange={handleDraftFieldChange}
        addField={addField}
        collections={enhancedCollections}
      />
    </>
  );
}
